<template>
	<div>
		<div id="map" style="width: 400px; height: 700px; float: right;"></div>
	</div>
</template>

<script>
	export default {
		name: 'MyMapComponent', // 您可以自定义组件名称
		data() {
			return {
				map: null,
				marker: null,
				circleCoords: null,
				myCircle: null,
				lat: "",
				lng: "",
				myRadius: 200, //半径的大小
				isShowLog: 0, //是否展示打印日志 0不显示 1显示
				myToyRole: "",
			};
		},
		mounted() {
			window.receiveData = this.receiveData; // 将 JavaScript 函数暴露给 Android
			window.initGaudMap = this.initGaudMap; // 将 JavaScript 函数暴露给 Android
			window.initMyLocation = this.initMyLocation; // 将 JavaScript 函数暴露给 Android
			window.setIsShowLog = this.setIsShowLog; // 将 JavaScript 函数暴露给 Android
			window.setMyRadius = this.setMyRadius; // 将 JavaScript 函数暴露给 Android
			window.getLocation = this.getLocation; // 将 JavaScript 函数暴露给 Android
			window.toLocation = this.toLocation; // 将 JavaScript 函数暴露给 Android
			window.autoInput = this.autoInput; // 将 JavaScript 函数暴露给 Android
			window.setPOI = this.setPOI; // 将 JavaScript 函数暴露给 Android

			// 在组件挂载后，直接使用全局的 aimap 对象进行初始化
			// 确保 aimap 库已加载
			if (typeof aimap !== 'undefined') {
				// 设置访问令牌和API地址
				//aimap.accessToken = 'UFJGhyFdSzvm0ZbecYglp6CssgnDK7PZ';//这个是测试的  这个好像已经不能用了
				aimap.accessToken = 'HvEgpw3yH14AkkHeG1M9CczwEFWslgEQ'; //这个是QIUI的  这个是之前申请的，18号过期
				//aimap.accessToken = 'ZzWUEDus5uQcjVWu9lIX66ADlchgl1Vi';//这个是QIUI的  上一个过期后新申请的
				aimap.baseApiUrl = 'https://location-dev.newayz.com';

				//-------------------------------------------------------------------
				// this.map = new aimap.Map({
				// 	container: 'map',
				// 	center: [113.150742, 23.066294], //中心点坐标
				// 	zoom: 17, //级别
				// 	pitch: 0,
				// 	bearing: 0,
				// 	style: 'aimap://styles/aimap/normal-v4'
				// });

				// this.marker = new aimap.Marker()
				// 	.setLngLat([113.150742, 23.066294])
				// 	.addTo(this.map);

				// this.circleCoords = this.getCirclePoints([113.150742, 23.066294], this.myRadius); // 调用函数，传入您的中心坐标和半径
				// this.map.on('load', () => {
				// 	this.myCircle = new aimap.Polygon({ // 使用 aimap.Polygon 绘制圆形
				// 		map: this.map,
				// 		data: {
				// 			"type": "Feature",
				// 			"properties": {},
				// 			"geometry": {
				// 				"type": "Polygon",
				// 				"coordinates": [this.circleCoords]
				// 			}
				// 		},
				// 		style: {
				// 			'fill-color': '#ee2200',
				// 			'fill-opacity': 0.5,
				// 		},
				// 		zIndex: 'edge_provincial_name',
				// 	});
				// });

				// this.map.on('click', (e) => { //地图点击
				// 	this.showInfoClick(e)
				// });

				// this.map.on('load', () => {
				//     const searching = new aimap.PlaceSearch();
				//     searching.search("南庄", (error, result) => {
				//         console.log(JSON.stringify(result));
				// 		//alert("result:"+JSON.stringify(result));
				//     });
				// })
				//-------------------------------------------------------------------
			}
		},
		methods: {
			//------------------------------------------------------APP与h5交互
			receiveData(data) {
				alert("接收APP的数据:" + data);
			},
			setIsShowLog(data) {
				this.isShowLog = data;
			},
			setMyRadius(data) {
				this.myRadius = data; //设置半径的大小
			},
			getLocation() { //获取当前的位置信息
				const requestData = {}; //传递的参数
				requestData.address = this.address;
				requestData.lat = this.lat;
				requestData.lng = this.lng;
				requestData.myRadius = this.myRadius;
				//alert("requestData:" + JSON.stringify(requestData));

				window.Android.getLocationAndroid(JSON.stringify(requestData));
			},
			initMyLocation(data) { //通过APP传递过来的数据 展示我所在的位置
				try {
					var str = data.slice(1, -1);
					var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组
					const lng = locationArray[0];
					const lat = locationArray[1];

					const popup = new aimap.Popup({
							closeOnClick: false
						})
						.setHTML(`
						        <div style="
						            padding: 12px 16px;
						            border-radius: 10px;
						            background: #1e90ff;
						            color: white;
						            box-shadow: 0 4px 12px rgba(30,144,255,0.4);
						            font-family: sans-serif;
						        ">
						            <div style="font-size: 16px; font-weight: bold;">
						                📌 当前所在位置
						            </div>
						            <div style="font-size: 13px; opacity: 0.9; margin-top: 3px;">
						                这是您的实时定位点
						            </div>
						        </div>
						    `);

					setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上
						// 构造点标记
						this.marker = new aimap.Marker()
							.setLngLat([locationArray[1], locationArray[0]])
							.setPopup(popup)
							.addTo(this.map);

						this.marker.togglePopup();
					}, 3000); // 等待3秒
				} catch (error) {
					alert("展示我所在的位置 error: " + error.message);
				}
			},
			initGaudMap(data) { //通过APP传递过来的数据 初始化地理位置
				try {
					if (this.isShowLog == 1) alert("初始化地理位置 接收到的数据:" + data);
					var str = data.slice(1, -1);
					var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组

					this.address = locationArray[2];
					this.lat = locationArray[0];
					this.lng = locationArray[1];

					if (this.isShowLog == 1) alert("初始化地理位置  解析数据完成");

					setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上

						if (this.isShowLog == 1) alert("初始化地理位置  开始渲染");

						//初始化地图
						this.map = new aimap.Map({
							container: 'map',
							center: [locationArray[1], locationArray[0]], //中心点坐标
							zoom: 15, //级别
							style: 'aimap://styles/aimap/normal-v4'
						});

						// 构造点标记
						/* this.marker = new aimap.Marker()
							.setLngLat([locationArray[1], locationArray[0]])
							.addTo(this.map); */

						// 在地图实例加载完成后绘制圆形
						const circleCoords = this.getCirclePoints([locationArray[1], locationArray[0]], this
							.myRadius); // 调用函数，传入您的中心坐标和半径
						this.map.on('load', () => {
							this.myCircle = new aimap.Polygon({ // 使用 aimap.Polygon 绘制圆形
								map: this.map,
								data: {
									"type": "Feature",
									"properties": {},
									"geometry": {
										"type": "Polygon",
										"coordinates": [circleCoords]
									}
								},
								style: {
									'fill-color': '#ee2200',
									'fill-opacity': 0.5
								},
								zIndex: 'edge_provincial_name',
							});
						});

						if (this.isShowLog == 1) alert("初始化地理位置  开始添加图层");

						this.map.on('click', (e) => { //地图点击
							this.showInfoClick(e)
						});

					}, 500); // 等待500毫秒
				} catch (error) {
					alert("初始化地理位置 error: " + error.message);
				}
			},
			toLocation(data) { //跳转到开锁定位的位置
				try {
					var str = data.slice(1, -1);
					var locationArray = str.split(","); // 使用逗号分隔字符串并拆分成数组

					this.lat = locationArray[0];
					this.lng = locationArray[1];
					this.myRadius = locationArray[3];
					this.myToyRole = locationArray[4];

					setTimeout(() => { // 等待一段时间，确保地图容器已经完全渲染到页面上

						this.map = new aimap.Map({
							container: 'map',
							center: [locationArray[1], locationArray[0]], //中心点坐标
							zoom: locationArray[2]-2, //级别
							style: 'aimap://styles/aimap/normal-v4'
						});

						/* this.marker = new aimap.Marker()
							.setLngLat([locationArray[1], locationArray[0]])
							.addTo(this.map); */

						const circleCoords = this.getCirclePoints([locationArray[1], locationArray[0]], this
							.myRadius); // 调用函数，传入您的中心坐标和半径
						this.map.on('load', () => {
							this.myCircle = new aimap.Polygon({ // 使用 aimap.Polygon 绘制圆形
								map: this.map,
								data: {
									"type": "Feature",
									"properties": {},
									"geometry": {
										"type": "Polygon",
										"coordinates": [circleCoords]
									}
								},
								style: {
									'fill-color': '#ee2200',
									'fill-opacity': 0.5
								},
								zIndex: 'edge_provincial_name',
							});
						});

						if (this.myToyRole == 1) {
							this.map.on('click', (e) => { //地图点击
								this.showInfoClick(e)
							});
						}
					}, 500); // 等待500毫秒
				} catch (error) {
					alert("跳转到开锁定位的位置 error: " + error.message);
				}
			},
			autoInput(data) { //POI搜索
				//alert("POI:" + data);
				try {
					const searching = new aimap.PlaceSearch();
					searching.search(data, (error, result) => {
						window.Android.getAutoInputAndroid(JSON.stringify(result));
					});
				} catch (error) {
					alert("Error occurred: " + error.message);
				}
			},
			setPOI(data) { //选中了POI
				this.toLocation(data);
			},
			//------------------------------------------------------------------------------------------------------------------------------------------------------------------
			showInfoClick(e) { //单击地图
				console.log(e);
				/* this.marker.remove();

				this.marker = new aimap.Marker()
					.setLngLat([e.lngLat.lng, e.lngLat.lat])
					.addTo(this.map); */

				const circleCoords = this.getCirclePoints([e.lngLat.lng, e.lngLat.lat], this.myRadius); // 调用函数，传入您的中心坐标和半径
				this.myCircle.setData({
					"type": "Feature",
					"properties": {},
					"geometry": {
						"type": "Polygon",
						"coordinates": [circleCoords]
					}
				});

				const lng = e.lngLat.lng;
				const lat = e.lngLat.lat;
				const lnglat = lng + ',' + lat;

				this.lat = lat;
				this.lng = lng;
			},
			getCirclePoints(center, radius, steps = 64) { // 这是一个用于计算圆形坐标点的函数，它使用地球半径和三角函数来模拟一个多边形。
				const degreesPerRadian = 180 / Math.PI;
				const earthRadius = 6378137; // 地球半径（米）
				const centerLng = center[0];
				const centerLat = center[1];
				const points = [];
				const radiusInRadians = radius / earthRadius;

				for (let i = 0; i <= steps; i++) {
					const bearing = (i * 360) / steps;
					const lat = Math.asin(Math.sin(centerLat * Math.PI / 180) * Math.cos(
							radiusInRadians) + Math.cos(centerLat * Math.PI / 180) *
						Math.sin(radiusInRadians) * Math.cos(bearing * Math.PI / 180));
					const lon = (centerLng * Math.PI / 180) + Math.atan2(Math.sin(bearing *
							Math.PI / 180) * Math.sin(radiusInRadians) * Math.cos(
							centerLat * Math.PI / 180), Math.cos(radiusInRadians) -
						Math.sin(centerLat * Math.PI / 180) * Math.sin(lat));
					points.push([lon * degreesPerRadian, lat * degreesPerRadian]);
				}
				return points;
			},
			//.....
		},
		beforeDestroy() {
			// 在组件销毁前，移除地图实例以释放资源
			if (this.map) {
				this.map.remove();
			}
		},
	};
</script>

<style scoped>
	/* 这里的样式只会应用于本组件 */
</style>